(function worker() {
	$.ajax({
		url: '/admin/index.html',
		success: function(data) {
		},
		complete: function() {
			// Schedule the next request when the current one's complete
			setTimeout(worker, 50000);
		}
	});
})();

var pet_types = [];
var urlParams = new URLSearchParams(window.location.search);
let map, infoWindow, marker;

pagePrivate = true;

jQuery(function($){ //on document.ready
	AOS.init();
	$.when( loginCheck, petTypesGet(), petStatusesGet() ).then(function() {
		if (userLoggedIn) {
			$('#lost_pet_content').show();
			$.each(pet_statuses, function (i,ps){
				if (ps) {
					if (ps.found) {
			        	$('#pet_status_input').append($('<option value="' + ps.ps_id + '">' + ps.name + '</option>'));
			      	}
		      	}
	     	});

			if (urlParams.has('pet[pet_id]')) {
				var petId = urlParams.get('pet[pet_id]');
				$('#pet-wait-msg').text('Loading Pet Details');
				$('#pet-wait').show();
				$('#pet_id_input').val(petId);

				// Load pet for editing
				$.ajax({
					type  : 'POST',
					url: '/utils/get_pet.php',
					dataType  : 'json',
					data: {'pet[pet_id]': petId},
					xhrFields: { withCredentials: true },
					crossDomain: true,
					encode  : true
				})
				.done(function(data) {
					$('#pet-wait').hide();
					if ( ! data.success) {
						//console.log(data);
						$('#pet-error-msg').html('Unable to load pet: ' + data.error_message);
						$('#pet-error').show();
						$('#found_pet_form').hide();
					} else {

						// Process article details for display
						$('#pet-error').hide();
						$('#found_pet_form').show();
						var pet = data.pet;
						//console.log(pet);
						//console.log('Pet:', order, JSON.stringify(pet, null, 2));

						$('#is_edit_input').val(1);

						$('#pet_type_input').val(pet.pet_type).change();
						$('#pet_status_input').val(pet.status).change();
						$('#pet_name').val(pet.name);
						$('#pet_color').val(pet.color);
						$('#pet_collar').val(pet.collar).change();
						$('#pet_description').val(pet.description);

						$('#lat').val(pet.loc_lat).change();
						$('#lng').val(pet.loc_lng).change();
						$('#lat_orig').val(pet.loc_lat);
						$('#lng_orig').val(pet.loc_lng);

						let pt = ($('#pet_type_input').val() ? $('#pet_type_input').val() : 6);
						let icon = petIcons[pt];
						icon.fillColor = '#2079e2';
						icon.strokeColor = icon.fillColor;

						let pos = {
							lat: pet.loc_lat,
							lng: pet.loc_lng,
						};
						marker.setIcon(icon);
						marker.setPosition(pos);
						map.setCenter(pos);
						$('.loading_msg').hide();

						// Display photos
						$.each( pet.photos, function(i,p) {
							//console.log(p);
							$("#highlight_check").attr('required','required');
							var pd = $('#photo_prototype').clone().show().removeAttr('id');
							pd.find('.uploading').hide();
							pd.find('.uploaded').show();
							pd.attr('id','list_' + p.pp_id);
							pd.find('a').attr('href', '/art/pet_photos/' + p.filename);
							pd.find('img').attr('src', '/art/pet_photos/thumbnail/' + p.filename).attr('id','image_' + p.pp_id + '_img');
							pd.find('.photo_id_input').val(p.pp_id).attr('id', 'photo_' + p.pp_id + '_input');
							pd.find('.highlight_radio').val(p.pp_id).attr('id', 'photo_' + p.pp_id + '_highlight_input');
							pd.find('.highlight-label').attr('for','photo_' + p.pp_id + '_highlight_input');
							pd.find('.delete').attr('data-type', 'POST').attr('data-url', window.location.origin + '/utils/pet_upload_server.php?file=' + p.filename + '&_method=DELETE');
							$('#results').append(pd);
						});
						$('[for=photo_' + pet.highlight_photo + '_highlight_input]').click();
						init_pp();

						$('#pet-wait').hide();
					}
				})
				.fail(function(XMLHttpRequest, textStatus, errorThrown) {
					console.log(XMLHttpRequest);
					console.log(textStatus);
					console.log(errorThrown);
					$('#pet-wait').hide();
					$('#pet-err-msg').html('Unable to load article: ' + textStatus);
					$('#pet-err').show();
				});


			}

			$('#pet-wait').hide();
			$('#found_pet_content').show();
		} else {
			window.location.replace('/register.html?return_url=' + window.location.pathname);
		}

		dragula([$("#results")[0]])
			.on('drop', function(el){
				var str = [];
				$.each( $('#results > div'), function(i,d) {
					var id = $(d).attr('id').replace('list_','');
					if (str.length != 0) { str = str + '&'; }
					str = str + 'list[]=' + id;
				});
				$.ajax({
					type: "GET",
					url: "/utils/do_image_sort.php",
					data: str
				});
			});

	});


	var petForm = document.getElementById('found_pet_form');
		petForm.addEventListener('submit', function(event) {
			event.preventDefault();
			event.stopPropagation();
			var formData = new FormData($('#found_pet_form')[0]);
			//console.log('Submitting');

			if (petForm.checkValidity() === false) {
				//console.log('Form invalid');

				// Form is not valid so show errors
				var wall = $("#pet-errors").show();

				// Remove old error messages
				wall.find("p").remove();

				// add new ones
				$.each($(':invalid'), function(index, error) {
					var msg = '';
					if ($(error).data('message')) {
						msg = $(error).data('message')
					} else {
						msg = $(error).next('.invalid-feedback').html();
					}
					if (msg) {
						wall.append("<p class='customErrors customBtnErr'>" + msg + "</p>");
					}
				});

			} else {
				//console.log('Form valid');
				// Form is valid so hide errors and submit
				$('#pet-errors,#pet-submit-div').hide();
				$('#pet-wait').show();

				$.ajax({
					 type: "POST",
					 url: $(petForm).attr('action'),
					 data: formData, // serializes the form's elements.
					 processData: false,
					 contentType: false,
					 dataType  : 'json',
					 xhrFields: { withCredentials: true },
					 encode  : true,
					 success: function(data) {
							$('#pet-wait').hide();
							$('input[type=submit]').hide();
							if (! data.success) {
								$('input[type=submit]').show();
								$('#pet-errors').show();
								var wall = $("#pet-errors");
								wall.find("p").remove();
								wall.append("<p><strong> Error submitting form: " + data.error_msg + "</strong></p>");
							} else {
								$('#pet-wait').hide();
								$('#pet-success').show();
								$('#found_pet_content').hide();
							}
					 }
				 });
			}
			petForm.classList.add('was-validated');
		}, false);

	$(document).on('click', '.highlight-label', function() {
		$('.highlight-label').removeClass('bg-success').addClass('bg-secondary').text('Make Highlight');
		$(this).removeClass('bg-secondary').addClass('bg-success').text('Highlighted').css('margin-bottom', '8px');
	});

	$("#lat").change(function() {
		$("#lat_disp").text($("#lat").val());
	});
	$("#lng").change(function() {
		$("#lng_disp").text($("#lng").val());
	});

	$(document).on("change", "#pet_type_input", function(e){
		let pt = ($(this).val() ? $(this).val() : 6);
		marker.setIcon(petIcons[pt]);
	});

	$(document).on("change", ".highlight_radio", function(e){
		$("#highlight_check").val($(this).val());
	});

	$(document).on("click", ".delete", function(e){
		e.preventDefault();
		var myBtn = $(this);
		var myDiv = myBtn.closest('.uploaded_item');

		var url = new URL($(this).data('url'));

		$.ajax({
			type : 'POST',
			url: url.pathname + '?' + url.searchParams.toString(),
			data: {'file': url.searchParams.get('file'), '_method': 'POST'},
			dataType: 'json',
			xhrFields: { withCredentials: true },
			crossDomain: true,
			encode  : true
		})
		.done(function(data){
			if (data[url.searchParams.get('file')]) {
				if ($(myDiv).hasClass('photo_proto')){
					if ($(myDiv).find('input').val()==$('#highlight_check').val()) {
						$('#highlight_check').val('');
					}
					if ($('.photo_proto').length == 2) {
						$('#highlight_check').removeAttr('required');
					}
				}
				myDiv.find('> div').hide();
				myDiv.find('.deleted').show();
				setTimeout(function() {
					myDiv.hide("slow", function(){
						myDiv.remove();
					});
				}, 3000);
			}
			else {
				myDiv.text('Error Deleting.');
			}
		})
		.fail(function(XMLHttpRequest, textStatus, errorThrown) {
			console.log(XMLHttpRequest);
			console.log(textStatus);
			console.log(errorThrown);
			$('#admin-wait').hide();
			$('#admin-err-msg').html('Unable to delete file: ' + textStatus);
			$('#admin-err').show();
		});
	});

	$(document).on("click", "#clear_rejects", function(e){
		e.preventDefault();
		$('#rejected_photos').empty();
		$('#rejected_photos_row').hide();
	})


});



window.init_pp = function () {
	// Select all links that contains lightbox in the attribute rel
	$("a[rel^='open-image']:visible").magnificPopup({
		type:'image',
		gallery:{
	 	   enabled:true
		}
	});
};

function initMap() {
	let pos = { lat: 32.7205172, lng: -114.6074127 };
	map = new google.maps.Map(document.getElementById("map_picker"), {
		center: pos,
		zoom: 14,
		styles: mapStyles,
	});
	infoWindow = new google.maps.InfoWindow();

	let icon = petIcons[6];
	icon.fillColor = '#18a04f';
	icon.strokeColor = icon.fillColor;
	icon.anchor = new google.maps.Point(192,512);
	marker = new google.maps.Marker({
		icon: icon,
		position: pos,
		map,
		draggable: true,
	});

	google.maps.event.addListener(marker, 'dragend', function(e) {
		$('#lat').val(e.latLng.lat());
		$('#lng').val(e.latLng.lng());
		$('#lat').change();
		$('#lng').change();
		var myLatLng = new google.maps.LatLng(e.latLng.lat(), e.latLng.lng());
		map.setCenter(myLatLng);
	});

	$('.loading_msg').show();
	if (!urlParams.has('pet[pet_id]')) {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(position) => {
					const pos = {
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					};
					$('.loading_msg').hide();
					$('#lat,#lat_orig').val(position.coords.latitude);
					$('#lng,#lng_orig').val(position.coords.longitude);
					$('#lat_disp').text(position.coords.latitude);
					$('#lng_disp').text(position.coords.longitude);

					let pt = ($('#pet_type_input').val() ? $('#pet_type_input').val() : 6);
					let icon = petIcons[pt];
					icon.fillColor = '#2079e2';
					icon.strokeColor = icon.fillColor;
					icon.anchor = new google.maps.Point(192,512);

					marker.setIcon(icon);
					marker.setPosition(pos);

					map.setCenter(pos);
					map.setZoom(18);
				},
				() => {
					 handleLocationError(true, infoWindow, map.getCenter());
				}
			);
		} else {
			// Browser doesn't support Geolocation
			 handleLocationError(false, infoWindow, map.getCenter());
		}
	}
}



function handleLocationError(browserHasGeolocation, infoWindow, pos) {
	$('.loading_msg').hide();
	var errText = browserHasGeolocation ? "Error: The Geolocation service failed." : "Error: Your browser doesn't support geolocation." ;
	$('#lat_disp').text($('#lat').val());
	$('#lng_disp').text($('#lng').val());
	$('.map-error').text(errText).fadeIn();
}

window.initMap = initMap;